import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createStore } from "zustand/vanilla";
import { MAX_PINS } from "../components/Header/SiteSelector/constants";

const SHARED_STORAGE_KEY = "connect:shared";

export interface SharedStore {
  pinnedSites: string[];
  setPinned: (sites: string[]) => void;
  togglePin: (siteName: string) => void;
}

export const sharedStore = createStore<SharedStore>()(
  devtools(
    persist(
      (set) => ({
        pinnedSites: [],
        setPinned: (sites) => set({ pinnedSites: sites }),
        togglePin: (siteName) =>
          set((state) => {
            if (state.pinnedSites.includes(siteName)) {
              return {
                pinnedSites: state.pinnedSites.filter((s) => s !== siteName),
              };
            }
            if (state.pinnedSites.length >= MAX_PINS) {
              return state;
            }
            return { pinnedSites: [...state.pinnedSites, siteName] };
          }, undefined),
      }),
      {
        name: SHARED_STORAGE_KEY,
        storage: createJSONStorage(() => localStorage),
      }
    ),
    {
      name: "Connect Shared Store",
      enabled: import.meta.env.DEV,
    }
  )
);
